import { Helmet } from 'react-helmet'
import { Cars } from 'data/types';

interface CarMetaTagsProps {
    carInfo: Cars;
}

const ProfileMetaTags: React.FC<CarMetaTagsProps> = ({ carInfo }) => {
    return (
        <Helmet>
            <title>Redline Specialist Cars - {`${carInfo.make} ${carInfo.model}`}</title>
            <meta name="description" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} data-react-helmet="true" />
            <meta name="keywords" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} data-react-helmet="true" />
            <meta property="og:title" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} data-react-helmet="true" />
            <meta property="og:description" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} data-react-helmet="true" />
            <meta property="og:image" content={carInfo.media?.images[0].href} data-react-helmet="true" />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Redline Specialist Cars" />

            <meta property="og:url" content={`https://5417-2a00-23c4-8009-3701-e882-8810-67ff-18ad.ngrok-free.app/`} />
            <meta property="og:type" content="website" />
            <meta property="og:title" content="Redline Specialist Cars" />
            <meta property="og:description" content="" />
            <meta property="og:image" content="" />

            <meta name="twitter:card" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} />
            <meta name="twitter:title" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} />
            <meta name="twitter:description" content={`${carInfo.make} ${carInfo.model} ${carInfo.derivative}`} />
            <meta name="twitter:image" content={carInfo.media?.images[0].href} />
        </Helmet>
    );
}

export default ProfileMetaTags;